export const common = {
    //Roles
    adminId: "65a7ca1c0d59fb1f949160c1",
    clubMemberId: "674d53d3354fafb6e2246b54",
    admin: "product-admin",
    clubOwner: "club-admin",
    clubManager: "club-manager",
    clubMember: "club-member",
}

export const clubMemberStatus = {
    new: "New",
    approved: "Approved",
    rejected: "Rejected"
}

export enum Role {
    admin = "product-admin",
    clubOwner = "club-admin",
    clubManager = "club-manager",
    Member = "club-member"
}

export enum Base {
    devBase = "azurewebsites",
    localBase = "localhost:3000",
    prodBase = "beefabric.in"
}

export enum ErrorMessages {
    popUp = "Failed to open popup window",
    invalidEmail = "Please enter valid email",
    missingFields = "Kindly fill all the fields with appropriate values",
    invalidFileType = "Invalid file format! Please upload a JPG or PNG image.",
    invalidMultiSelectType = "Some files have an invalid format! Please upload only JPG or PNG images."
}

export enum module{
    event= "Event",
    club="Club",
    gallery="Image",
    comment= "Comment"
}

export enum clubCategory {
    myClub  = "myClub",
    publicClub = "public"
}

export enum subDomain {
    www= "www"
}

export const allowedFormats = ["image/jpeg", "image/png", "image/jpg"];